export enum ErrorsType{
    Warning,
    Error
}